import _get from './get';
import _post from './post';

const AgendaManager = {
	_get,
	_post
};

export default AgendaManager;
